"use strict";

angular.module("core")
.controller("SupportAssistantModalController", function(
    $scope, $location, gettextCatalog, close, moment, UserService, FormError, PatternService, RequestSupportService,
    FlashBag, IS_MOBILE_APP, SUPPORT_PHONE_NUMBER, EMAIL_MAXLENGTH
) {
    var _this = this;
    $scope.DESCRIPTION_MAX_LENGTH = 1000;
    $scope.EMAIL_MAXLENGTH = EMAIL_MAXLENGTH;
    $scope.nestedObject = {};
    $scope.pattern = PatternService;
    $scope.request = {
        timezone: moment.tz.guess(),
        referrer_url: $location.absUrl()
    };
    $scope.isMobileApp = IS_MOBILE_APP;
    $scope.supportPhoneNumber = SUPPORT_PHONE_NUMBER;

    UserService.isUserFetched().then(function onSuccess(user) {
        if (user) {
            $scope.request["email"] = user.email;

            var first_name = user.first_name || "";
            var last_name = user.last_name || "";
            $scope.request["name"] = (first_name + " " + last_name).trim();
            $scope.request["company_name"] = user.info.company_name;
            $scope.request["timezone"] = user.info.timezone;
            $scope.request["phone"] = user.info.office_phone;
        }
    });

    this.close = function() {
        $scope.$element.modal("hide");
        $scope.$element.remove();
        close.apply(this, arguments);
    };

    this.send = function() {
        $scope.nestedObject.requestSupportForm.$setSubmitted();
        if ($scope.nestedObject.requestSupportForm.$valid) {
            RequestSupportService.post($scope.request).then(
                function onSuccess() {
                    _this.close();
                    FlashBag.success(gettextCatalog.getString("You will be contacted in the next working day hour."), true);
                },
                function onFailure(response) {
                    FlashBag.apiError(response);
                }
            );
        } else {
            FormError.focus("nestedObject.requestSupportForm");
        }
    };
});



//////////////////
// WEBPACK FOOTER
// ./core/support-assistant/support-assistant.modal.js
// module id = 665
// module chunks = 0